export default {
  GET_LIST: '/auth/hit/findReviewHistoryList',
  GET_MODULE_LIST: '/auth/hit/module'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/recentlyViewed.js